// extracted by css-extract-rspack-plugin
export default {"badge":"Badge__badge--rUCPv","badgeGreen":"Badge__badgeGreen--vVAQb","badgeOrange":"Badge__badgeOrange--ACGrd","badgeBlue":"Badge__badgeBlue--d0QFU"};